import React from 'react';
import { Container } from 'react-bootstrap';
import SprintSectionHeader from './sprint-section-header';

export default function SprintProcessGrid({ 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    subtitle, 
    steps 
}) {
    return (
        <section className="sprint-process">
            <Container>
                <SprintSectionHeader 
                    label={label}
                    titlePrefix={titlePrefix}
                    highlightText={highlightText}
                    titleSuffix={titleSuffix}
                    subtitle={subtitle}
                    center={true}
                />
                
                <div className="sprint-process-grid">
                    {steps && steps.map((step, idx) => (
                        <div className={`sprint-process-card sprint-reveal sprint-delay-${(idx % 6) + 1}`} key={idx}>
                            <div className="sprint-card-header">
                                <span className="sprint-card-num">
                                    {step.num < 10 ? `0${step.num}` : step.num}
                                </span>
                                <div className="sprint-card-icon-wrap">{step.icon}</div>
                            </div>
                            <div className="sprint-card-body">
                                <h4>{step.title}</h4>
                                <p>{step.desc}</p>
                            </div>
                            <div className="sprint-card-indicator"></div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
